module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-widget-padding",
    class: {
      'col-sm-4': !_vm.widget.doubleSize, 'col-sm-8': _vm.widget.doubleSize, 'yes-link': _vm.hasLink, 'no-link': !_vm.hasLink
    },
    on: {
      "click": function($event) {
        _vm.goToLink()
      }
    }
  }, [((_vm.widget.title != null && _vm.widget.title.length > 0)) ? _c('div', {
    staticClass: "section_title_box"
  }, [(_vm.widget.title != null && _vm.widget.title.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 no-widget-padding"
  }, [_c('div', {
    staticClass: "section_title"
  }, [_c('div', {
    staticClass: "section_title_cont text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.widget.title))])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 no-widget-padding"
  }, [_c('div', {
    staticClass: "soproni_small_img_box"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.widget.imageUrl,
      "alt": ""
    }
  })])])])]) : _vm._e(), _vm._v(" "), (!(_vm.widget.title != null && _vm.widget.title.length > 0)) ? _c('div', {
    staticClass: "coca_cola"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.widget.imageUrl,
      "alt": ""
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aec84cac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/page/widgets/CardWidget.vue
// module id = 126
// module chunks = 0 1 2